<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container position-relative bg-white mx-auto px-1 px-lg-7 py-7">

                    <div class="modal-header mb-4">
                        <slot name="header"></slot>
                        <button class="position-absolute icon icon__close-grey p-2" @click="$emit('close')"></button>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "CatUxoModal",
        mounted() {
        }
    }
</script>
<style lang="scss" scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        min-height: 100vh;
        height: 100vh;
        background-color: rgba(0, 0, 0, .2);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: calc(100% - 24px);
        max-width: rem(984px);
        border-radius: $border-radius-sm;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.03);
        transition: all .3s ease;
        max-height: 100vh;
        overflow-y: scroll;

        @include media-breakpoint-up(sm) {
            width: calc(100% - 64px);
        }
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        transform: scale(1.1);
    }

    .icon {
        top: 0;
        right: 0;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/shared/Modal.vue